module.exports = __webpack_public_path__ + "static/media/i1.7c671f4b.png";